<template>
    <BootstrapModal
        ref="tiktokModalProfileRef"
        modalId="tiktok-modal-profile"
        modalSize="l"
        :title="'TikTok - Make Your Day'"
        :closeText="'Close'"
        :loading="isLoading"
    >
        <template #left-icon>
            <svg
                @click="showPopup = true"
                width="1.5rem"
                height="1.5rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
                        fill="#999"
                    ></path>
                </g>
            </svg>
        </template>
        <template #body>
            <div class="text-center py-4">
                <!-- Avatar -->
                <img
                    :src="profile.avatar_url"
                    alt="Avatar"
                    class="rounded-circle mb-3 m-auto"
                    style="width: 96px; height: 96px; object-fit: cover"
                />

                <!-- Display Name -->
                <h5 class="mb-1">{{ profile.display_name }}</h5>
                <!-- Follower & Like Count -->
                <p
                    class="text-muted small"
                    v-if="profile.follower_count && profile.likes_count"
                >
                    {{ formatNumber(profile.follower_count) }} Followers •
                    {{ formatNumber(profile.likes_count) }} Likes
                </p>

                <!-- Follow Button -->
                <a
                    :href="'https://www.tiktok.com/@' + profile.username"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <AppButton :black="true" width="auto" class="mt-3">
                        Follow on TikTok
                    </AppButton>
                </a>

                <!-- Powered By TikTok -->
                <div class="powered-by-tiktok mt-4">
                    <hr class="my-3" />
                    <div
                        class="d-flex justify-content-center align-items-center gap-1 text-muted small"
                    >
                        <span>Powered By</span>
                        <img
                            src="/template/allmyonline/assets/icons/tiktok.svg"
                            alt="TikTok"
                            style="height: 16px; margin-left: 6px"
                        />
                    </div>
                </div>
            </div>
        </template>
    </BootstrapModal>

    <BootstrapModal
        ref="tiktokVideosModalRef"
        modalId="tiktok-modal-videos"
        modalSize="l"
        :title="'TikTok Videos'"
        :closeText="'Close'"
        :loading="isLoading"
    >
        <template #left-icon>
            <svg
                @click="showPopup = true"
                width="1.5rem"
                height="1.5rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
                        fill="#999"
                    ></path>
                </g>
            </svg>
        </template>
        <template #body>
            <div class="py-4 text-center">
                <!-- TikTok Profile Header -->
                <div
                    class="d-flex align-items-center justify-content-start mb-4 px-3"
                >
                    <img
                        :src="dataTiktokProfile.avatar_url"
                        alt="Avatar"
                        class="rounded-circle me-3"
                        style="width: 48px; height: 48px"
                    />
                    <div class="text-start">
                        <div class="fw-bold">
                            {{ dataTiktokProfile.username }}
                        </div>
                        <small
                            class="text-muted"
                            v-if="
                                dataTiktokProfile.follower_count &&
                                dataTiktokProfile.likes_count
                            "
                        >
                            {{ formatNumber(dataTiktokProfile.follower_count) }}
                            Followers •
                            {{ formatNumber(dataTiktokProfile.likes_count) }}
                            Likes
                        </small>
                    </div>
                </div>

                <!-- Carousel for Videos -->
                <Carousel
                    v-if="listTikTokVideos.length"
                    :itemsToShow="2"
                    :wrapAround="true"
                    :mouseDrag="true"
                    :pauseAutoplayOnHover="true"
                    :transition="500"
                >
                    <Slide
                        v-for="video in listTikTokVideos"
                        :key="video.id"
                        class="px-2"
                    >
                        <div
                            v-html="video.embed_html"
                            class="video-wrapper border rounded overflow-hidden"
                        ></div>
                    </Slide>

                    <template #addons>
                        <Navigation />
                        <Pagination />
                    </template>
                </Carousel>

                <!-- Follow Button -->
                <AppButton :black="true" width="100%" class="mt-2 mb-2">
                    <a
                        :href="
                            'https://www.tiktok.com/@' +
                            dataTiktokProfile.username
                        "
                        target="_blank"
                        style="text-decoration: none"
                    >
                        Follow on TikTok
                    </a>
                </AppButton>

                <!-- Powered by -->

                <div
                    class="mt-2 text-muted small d-flex justify-content-center align-items-center gap-2"
                >
                    <span>Powered by</span>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="5rem"
                        height="100%"
                        viewBox="0 0 1000 291.379"
                        enable-background="new 0 0 1000 291.379"
                    >
                        <g>
                            <path
                                fill="#FF004F"
                                d="M191.102,105.182c18.814,13.442,41.862,21.351,66.755,21.351V78.656c-4.711,0.001-9.41-0.49-14.019-1.466
v37.686c-24.891,0-47.936-7.909-66.755-21.35v97.703c0,48.876-39.642,88.495-88.54,88.495c-18.245,0-35.203-5.513-49.29-14.968
c16.078,16.431,38.5,26.624,63.306,26.624c48.901,0,88.545-39.619,88.545-88.497v-97.701H191.102z M208.396,56.88
c-9.615-10.499-15.928-24.067-17.294-39.067v-6.158h-13.285C181.161,30.72,192.567,47.008,208.396,56.88L208.396,56.88z
M70.181,227.25c-5.372-7.04-8.275-15.652-8.262-24.507c0-22.354,18.132-40.479,40.502-40.479
c4.169-0.001,8.313,0.637,12.286,1.897v-48.947c-4.643-0.636-9.329-0.906-14.013-0.807v38.098c-3.976-1.26-8.122-1.9-12.292-1.896
c-22.37,0-40.501,18.123-40.501,40.48C47.901,206.897,56.964,220.583,70.181,227.25z"
                            ></path>
                            <path
                                d="M177.083,93.525c18.819,13.441,41.864,21.35,66.755,21.35V77.189c-13.894-2.958-26.194-10.215-35.442-20.309
c-15.83-9.873-27.235-26.161-30.579-45.225h-34.896v191.226c-0.079,22.293-18.18,40.344-40.502,40.344
c-13.154,0-24.84-6.267-32.241-15.975c-13.216-6.667-22.279-20.354-22.279-36.16c0-22.355,18.131-40.48,40.501-40.48
c4.286,0,8.417,0.667,12.292,1.896v-38.098c-48.039,0.992-86.674,40.224-86.674,88.474c0,24.086,9.621,45.921,25.236,61.875
c14.087,9.454,31.045,14.968,49.29,14.968c48.899,0,88.54-39.621,88.54-88.496V93.525L177.083,93.525z"
                            ></path>
                            <path
                                fill="#00F2EA"
                                d="M243.838,77.189V66.999c-12.529,0.019-24.812-3.488-35.442-10.12
C217.806,67.176,230.197,74.276,243.838,77.189z M177.817,11.655c-0.319-1.822-0.564-3.656-0.734-5.497V0h-48.182v191.228
c-0.077,22.29-18.177,40.341-40.501,40.341c-6.554,0-12.742-1.555-18.222-4.318c7.401,9.707,19.087,15.973,32.241,15.973
c22.32,0,40.424-18.049,40.502-40.342V11.655H177.817z M100.694,114.408V103.56c-4.026-0.55-8.085-0.826-12.149-0.824
C39.642,102.735,0,142.356,0,191.228c0,30.64,15.58,57.643,39.255,73.527c-15.615-15.953-25.236-37.789-25.236-61.874
C14.019,154.632,52.653,115.4,100.694,114.408z"
                            ></path>
                            <path
                                fill="#FF004F"
                                d="M802.126,239.659c34.989,0,63.354-28.136,63.354-62.84c0-34.703-28.365-62.844-63.354-62.844h-9.545
c34.99,0,63.355,28.14,63.355,62.844s-28.365,62.84-63.355,62.84H802.126z"
                            ></path>
                            <path
                                fill="#00F2EA"
                                d="M791.716,113.975h-9.544c-34.988,0-63.358,28.14-63.358,62.844s28.37,62.84,63.358,62.84h9.544
c-34.993,0-63.358-28.136-63.358-62.84C728.357,142.116,756.723,113.975,791.716,113.975z"
                            ></path>
                            <path
                                d="M310.062,85.572v31.853h37.311v121.374h37.326V118.285h30.372l10.414-32.712H310.062z M615.544,85.572v31.853h37.311
v121.374h37.326V118.285h30.371l10.413-32.712H615.544z M432.434,103.648c0-9.981,8.146-18.076,18.21-18.076
c10.073,0,18.228,8.095,18.228,18.076c0,9.982-8.15,18.077-18.228,18.077C440.58,121.72,432.434,113.63,432.434,103.648z
M432.434,134.641h36.438v104.158h-36.438V134.641z M484.496,85.572v153.226h36.452v-39.594l11.283-10.339l35.577,50.793h39.05
l-51.207-74.03l45.997-44.768h-44.258l-36.442,36.153V85.572H484.496z M877.623,85.572v153.226h36.457v-39.594l11.278-10.339
l35.587,50.793H1000l-51.207-74.03l45.995-44.768h-44.256l-36.452,36.153V85.572H877.623z"
                            ></path>
                            <path
                                d="M792.578,239.659c34.988,0,63.358-28.136,63.358-62.84c0-34.703-28.37-62.844-63.358-62.844h-0.865
c-34.99,0-63.355,28.14-63.355,62.844s28.365,62.84,63.355,62.84H792.578z M761.336,176.819c0-16.881,13.8-30.555,30.817-30.555
c17.005,0,30.804,13.674,30.804,30.555s-13.799,30.563-30.804,30.563C775.136,207.379,761.336,193.7,761.336,176.819z"
                            ></path>
                        </g>
                    </svg>
                </div>
            </div>
        </template>
    </BootstrapModal>

    <SharePopup
        :show="showPopup"
        :username="username"
        :urlName="urlName"
        :shortCode="shortCode"
        @close="showPopup = false"
    />
</template>
<script>
import AppButton from "@/Components/AppButton.vue";
import BootstrapModal from "@/Components/BootstrapModal.vue";
import SharePopup from "@/Components/SharePopup.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
export default {
    components: {
        AppButton,
        Carousel,
        Slide,
        Pagination,
        Navigation,
        SharePopup,
        BootstrapModal,
    },
    props: {
        DoBucket: {
            type: String,
            required: true,
        },
        DoEndpoint: {
            type: String,
            required: true,
        },
        username: "",
        urlName: "",
        mobileView: {
            required: false,
            default: 1.5,
        },
    },
    data() {
        return {
            listTikTokVideos: [],
            dataTiktokProfile: {},
            profile: {},
            isLoading: false,
            showPopup: false,
            shortCode: "",
            carouselBreakpoints: {
                768: { itemsToShow: 2 },
                576: { itemsToShow: 1.2 },
            },
        };
    },

    mounted() {},
    methods: {
        formatNumber(num) {
            if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
            if (num >= 1000) return (num / 1000).toFixed(1) + "K";
            return num.toString();
        },
        openShareMenu() {
            this.showShareMenu = true;
        },
        closeTikTokProfileModal() {
            this.$refs.tiktokModalProfileRef.closeModal("tiktok-embed-modal");
        },
        // OLD: showTikTokModal(link)
        openTikTokVideosModal(link) {
            this.listTikTokVideos = [];
            this.isLoading = true;
            this.shortCode = link.short_code;

            this.$refs.tiktokVideosModalRef.showModal("tiktok-modal-videos");

            axios
                .get(route("tiktok.videos.by.link", { id: link.id }))
                .then((res) => {
                    this.listTikTokVideos = res.data.videos || [];
                    this.dataTiktokProfile = res.data.analytic || {};
                })
                .catch((err) => {
                    console.error("Failed to load TikTok videos", err);
                })
                .finally(() => {
                    this.isLoading = false;
                    // ensure TikTok embed script runs after DOM update
                    this.$nextTick(() => {
                        if (
                            window.tiktok &&
                            typeof window.tiktok.embedLoad === "function"
                        ) {
                            window.tiktok.embedLoad();
                        } else {
                            const s = document.createElement("script");
                            s.src = "https://www.tiktok.com/embed.js";
                            s.async = true;
                            document.body.appendChild(s);
                        }
                    });
                });
        },
        showTikTokProfileModal(link) {
            this.profile = {}; // reset old data
            this.isLoading = true; // start spinner

            // open the modal first
            this.$refs.tiktokModalProfileRef.showModal("tiktok-modal-profile");

            axios
                .get(route("tiktok.profile.only", { id: link.id }))
                .then((res) => {
                    this.profile = res.data; // fill profile
                })
                .catch((err) => {
                    console.error("Failed to load TikTok profile", err);
                    this.$toast?.error("Could not load TikTok profile");
                })
                .finally(() => {
                    this.isLoading = false; // stop spinner even on error
                });
        },
        redirectToLinkTikTokProfile(data) {
            return window.open(data.url, "_blank");
        },
    },
};
</script>
<style>
.video-wrapper {
    max-height: 360px; /* adjust this as needed */
    overflow: hidden;
}

.video-wrapper iframe,
.video-wrapper blockquote {
    max-height: 360px;
    height: 100%;
    width: 100%;
    object-fit: cover;
}
</style>
